




























import { Component, Vue, Watch } from 'vue-property-decorator'
import marked from 'marked'
import { linkRenderer } from '@/utils/Markdown'

@Component
export default class MessageBox extends Vue {
  public message: string = ''
  public messageCache: string[] = []

  public created() {
    this.setMessageCache()
  }

  public sendMessageToGuest() {
    this.$emit('input', this.message)

    this.addMessageToCache(this.message)
    this.message = ''
    ;(this.$refs.input as HTMLInputElement).focus()
  }

  public setPreviousMessage(msg: string) {
    if (!msg) {
      return
    }

    this.message = msg
  }

  public markThis(txt: string) {
    marked.setOptions({
      renderer: linkRenderer,
    })
    return marked(txt)
  }

  @Watch('messageCache')
  private handleMessageCache() {
    localStorage.setItem('waiterMessageCache', JSON.stringify(this.messageCache))
  }

  private setMessageCache() {
    const cacheStr = localStorage.getItem('waiterMessageCache')
    this.messageCache = cacheStr ? JSON.parse(cacheStr) : []
  }

  private addMessageToCache(msg: string) {
    if (!msg) {
      return
    }

    const indexOfMessage = this.messageCache.indexOf(msg)
    if (indexOfMessage !== -1) {
      this.messageCache.splice(indexOfMessage, 1)
    }

    this.messageCache.unshift(msg)
    this.messageCache = this.messageCache.slice(0, 3)
  }
}
